import type { FC } from "react";
import { Input, Stack, Text, Textarea } from "@mantine/core";
import { FileList, type Order } from "@jasper/shared";
import { useOrderHelpRequest } from "/@/pages/orders/useOrderHelpRequest";
import type { OrderPageState } from "../useOrderPage";
import { PhoneUploadQrCard } from "/@/components/order/PhoneUploadQrCard";
import { OrderRequestPanel, REQUEST_ERROR_MESSAGE } from "./OrderRequestPanel";

type OrderHelpPanelProps = {
  order: Order;
  state: OrderPageState;
};

export const OrderHelpPanel: FC<OrderHelpPanelProps> = ({ order, state }) => {
  const { refetch, requests, actions } = state;
  const {
    qrCodeCanvasRef,
    hasFiles,
    filesToShow,
    deleteOneHelpFile,
    refetchHelpFiles,
    setHelpRequestMessage,
    submit,
    error,
  } = useOrderHelpRequest({
    order,
    id: actions.getHelpTempId(),
    refetch,
    onSent: requests.help.close,
  });

  return (
    <OrderRequestPanel
      title="Une précision oubliée ?"
      subtitle="Votre conseiller Jasper la reçoit tout de suite. Possible tant que la commande n'est pas livrée."
      hint="Ajoutée aux notes du praticien"
      errorMessage={error ? REQUEST_ERROR_MESSAGE : null}
      submitLabel="Envoyer"
      onSubmit={submit}
      onClose={requests.help.close}
    >
      <Textarea
        aria-label="Votre précision"
        placeholder="Ex. : prévoir un léger surcontour vestibulaire sur la 15"
        onChange={event => setHelpRequestMessage(event.target.value)}
        autosize
        minRows={3}
        maxRows={12}
      />
      {/* Design system §13: label above, "(optionnel)" in grey. */}
      <Input.Wrapper
        labelElement="div"
        label={
          <>
            Photos{" "}
            <Text span variant="caption">
              (optionnel)
            </Text>
          </>
        }
      >
        <Stack gap="s2">
          <PhoneUploadQrCard canvasRef={qrCodeCanvasRef} />
          {hasFiles && (
            <FileList
              files={filesToShow}
              downloadOneFile={() => {}}
              deleteOneFile={deleteOneHelpFile}
              refetch={refetchHelpFiles}
            />
          )}
        </Stack>
      </Input.Wrapper>
    </OrderRequestPanel>
  );
};
